import { WhichWeightAPI } from 'WhichWeightAPI';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOrganizationCoaches } from 'redux/slices/organization';

export const useGetCoaches = () => {
    
    const dispatch = useDispatch();

    const organizationId = useSelector(state => state.user.organizationId);
    const cachedCoaches = useSelector(state => state.organization.coaches);

    const [coaches, setCoaches] = useState(cachedCoaches);

    const FetchCoachesFromBackend = async () => {
        const jsonBody = {
            organizationId: organizationId
        }

        // console.log(jsonBody);

        const result = await WhichWeightAPI("REPORTING", "GET", "/organization_trainers", jsonBody);

        // console.log(result.data.data);

        dispatch(setOrganizationCoaches(result.data.data));

        setCoaches(result.data.data);
    }

    useEffect(() => {
        if (organizationId === null) return;

        if (cachedCoaches === null) {
            FetchCoachesFromBackend();
        }
    }, [cachedCoaches, dispatch]);

    return coaches;
};